window.theme.component('login-form', el => {
	const loginForm = el.querySelector('.js-form-login');
	const modalLogin = document.querySelector('.js-modal-login');
	const registerForm = document.querySelector('.js-form-cadastro');
	const triggers = document.querySelectorAll('.js-open-modal-login');

	if (triggers) {
		triggers.forEach(function (trigger) {
			trigger.addEventListener('click', function () {
				helper.openModal(modalLogin);
			});
		});
	}

	if (loginForm) {
		loginForm.addEventListener('submit', event => {
			event.preventDefault();

			loginForm.classList.add('loading');
			const formData = helper.serializeForm(loginForm);
			const validationWrapper = loginForm.querySelector('.js-validation');
			validationWrapper.innerHTML = '';
			validationWrapper.classList.add('hidden');

			const data = Object.assign({}, formData, {
				action: 'loga_usuario',
				redirect_to: window.location.href
			});

			fetch(`${config.ajax_url}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams(data)
			})
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						helper.logMessage('Usuário logado com sucesso, redirecionando...', 'success');
						setTimeout(() => {
							if(window.location.href.indexOf('senha') !== -1) {
								window.location.href = '/minha-conta/';

								return false;
							}
							
							window.location.reload();
						}, 1500);
					} else {
						validationWrapper.classList.remove('hidden');
						helper.logMessage(data.message, 'error', { target: validationWrapper });
						loginForm.classList.remove('loading');
					}
				});
		});

		const forgotForm = document.querySelector('.js-form-forgot form');
		const forgotLink = document.querySelectorAll('.js-link-forgot-password');
		
		if (forgotLink && forgotForm) {
			forgotLink.forEach(link => {
				link.addEventListener('click', e => {
					e.preventDefault();
					const target = document.querySelector('.js-form-forgot');

					if (target) {
						loginForm.classList.toggle('hidden');
						target.classList.toggle('hidden');
					}
				});
			});

			forgotForm.addEventListener('submit', event => {
				event.preventDefault();

				const formData = helper.serializeForm(forgotForm);
				const validationWrapper = forgotForm.querySelector('.js-validation');
				validationWrapper.innerHTML = '';
				validationWrapper.classList.add('hidden');

				const data = Object.assign({}, formData, {
					action: 'forgot_password'
				});

				fetch(`${config.ajax_url}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: new URLSearchParams(data)
				})
					.then(response => response.json())
					.then(data => {
						if (data.success) {
							validationWrapper.classList.remove('hidden');
							helper.logMessage(data.message, 'success', { target: validationWrapper });							
						} else {
							validationWrapper.classList.remove('hidden');
							helper.logMessage(data.message, 'error', { target: validationWrapper });
						}
					});
			});
		}
	}

	if (registerForm) {
		registerForm.addEventListener('submit', event => {
			event.preventDefault();

			registerForm.classList.add('loading');
			const formData = helper.serializeForm(registerForm);
			const validationWrapper = registerForm.querySelector('.js-validation');
			validationWrapper.innerHTML = '';
			validationWrapper.classList.add('hidden');

			const data = Object.assign({}, formData, {
				action: 'registra_usuario',
				redirect_to: window.location.href
			});

			fetch(`${config.ajax_url}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams(data)
			})
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						// helper.closeModal(modalLogin)
						helper.logMessage('Usuário registrado com sucesso, redirecionando...', 'success');
						setTimeout(() => {
							window.location.reload();
						}, 1500);
					} else {
						validationWrapper.classList.remove('hidden');
						helper.logMessage(data.message, 'error', { target: validationWrapper });
						registerForm.classList.remove('loading');
					}
				});
		});
	}

});